<div style="display: inline-block; background-color: #ffff8d; padding: 2px 5px; white-space: nowrap;"
	*ngIf="filtered">
	<span translate>
		Data is filtered.
	</span>
	<button mat-button
		(mouseover)="clearHover = true"
		(mouseout)="clearHover = false"
		[@hovered]="clearHover ? 'hover' : 'no-hover'"
		(click)="clearFilter.emit()">
        <span translate>CLEAR FILTERS</span>
	</button>
</div>
